import { render, staticRenderFns } from "./barcode-config.vue?vue&type=template&id=5db68ae6&scoped=true&"
import script from "./barcode-config.vue?vue&type=script&lang=js&"
export * from "./barcode-config.vue?vue&type=script&lang=js&"
import style0 from "./barcode-config.vue?vue&type=style&index=0&id=5db68ae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db68ae6",
  null
  
)

export default component.exports